import React, { useEffect, useState } from 'react';
import InfoBascula from './InfoBascula';
import { Button, Grid, Paper, Tooltip, Typography, makeStyles, useMediaQuery, withStyles } from '@material-ui/core';
import { ImcGenericStyle } from '../ImcGeneric/ImcGenericStyle';
import clsx from 'clsx';
import PieChartGenero from './PieChartGenero';
import ChartIes from './ChartIes';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import './graficas.css'

export const GenericBascula = ({ fechaIni, fechaFin, femenino, masculino, sinregistrar, infoBascula, dataBascula, titlePanel, idBascula, porcentage, total, total_users }) => {

    const history = useHistory();
    const classes = ImcGenericStyle();
    const fixedHeightTarg = clsx(classes.paper, classes.fixedHeightTarg);
    const [dataFilter, setdataFilter] = useState({})
    const [, setgenericIESs] = useState({})
    const Femenino = femenino !== undefined && femenino !== "" ? femenino : 0;
    const Masculino = masculino !== undefined && masculino !== "" ? masculino : 0;
    const sinRegistrar = sinregistrar !== undefined && sinregistrar !== "" ? sinregistrar : 0;

    const filterDataBascula = () => {
        dataBascula.map((item) => {
            if (parseInt(item.id) === parseInt(idBascula)) {
                setdataFilter(item)
            }
        })
    }

    const customDataBascula = () => {

        // let newObject = []

        setgenericIESs(infoBascula.genericIESs)

    }
    const isSmallScreen = useMediaQuery('(max-width:1152px)');


    useEffect(() => {
        filterDataBascula()
        customDataBascula()

    }, [idBascula, dataBascula])

    const handleLinkClick = () => {
        // Parsear las fechas antes de sumar dos días
        let fechaIniParseada = new Date(Date.parse(fechaIni));
        let fechaFinParseada = new Date(Date.parse(fechaFin));

        // Sumar dos días a fechaIni y fechaFin
        let fechaIniModificada = new Date(fechaIniParseada);
        let fechaFinModificada = new Date(fechaFinParseada);
        fechaIniModificada.setDate(fechaIniModificada.getDate() + 1);
        fechaFinModificada.setDate(fechaFinModificada.getDate() + 1);

        // Realiza el redireccionamiento

        let parametros = {
            fechaIinicial: fechaIniModificada,
            fechaFinal: fechaFinModificada,
            nameBascula: titlePanel
        };
        history.push(`/mediciones/detalles/user/${idBascula}`, parametros);
    };
    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(15),
            border: '1px solid #dadde9',
        },
    }))(Tooltip);


    return (
        <>
            <Grid item xs={12} md={6} lg={6} style={{ height: '20%' }}>
                <Paper className={`${fixedHeightTarg} custom-card`}>
                    <InfoBascula
                        max={infoBascula.maxUser}
                        dataBascula={dataFilter}
                        porcentage={porcentage}
                        total={total}
                        total_users={total_users}
                        data={dataFilter} />
                    <Button
                        color="primary"
                        variant="contained"
                        style={{ width: '39%', marginLeft: "30%", marginTop: "6%", borderRadius: "8px" }}
                        onClick={() => handleLinkClick()}>
                        Detalle de usuarios
                    </Button>
                    <div align="right" style={{ height: '21px' }}>
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography>Descripción</Typography>
                                    <b><br />{"NOMBRE:"}</b>{' '}
                                    {"Bscula seleccionada."}
                                    <br />
                                    <b><br />{"USUARIOS FILTRADOS:"}</b>{' '}
                                    {"Total de usuarios que han usado la isla en el rango de fechas seleccionado."}
                                    <br />
                                    <b><br />{"NÚMERO TOTAL DE USUARIOS:"}</b>{' '}
                                    {"Total de usuarios asignados a la bascula seleccionada."}
                                    <br />
                                    <b><br />{"PORCENTAJE DE USO:"}</b>{' '}
                                    {"Porcentaje de los usuarios totales que han utilizado la bascula en el rango de fechas seleccionado."}
                                </React.Fragment>
                            }
                            placement="right-start"
                        >
                            <HelpOutlineIcon color='primary' />
                        </HtmlTooltip>
                    </div>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
                <Paper className={fixedHeightTarg} >

                    <PieChartGenero
                        femenino={Femenino}
                        masculino={Masculino}
                        sinregistrar={sinRegistrar}
                        dataBascula={dataFilter} dataGenero={infoBascula.genero !== undefined ? infoBascula.genero : []} />
                </Paper>
            </Grid>

            {/*INDICE DE EMPLEADO SALUDABLE*/}
            <Grid item xs={12} md={12} lg={12}>
                <Paper className={`${fixedHeightTarg} custom-card`} style={{ overflowY: isSmallScreen ? 'auto' : 'hidden' }}>
                    <ChartIes
                        data={infoBascula}
                        max={infoBascula.maxUser}
                        fechaFin={fechaIni}
                        fechaIni={fechaFin} />
                </Paper>
            </Grid>
        </>
    )



}